/*=========================================================================================
  File Name: moduleChatState.js
  Description: Chat Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  // Chat Search Query
  chatSearchQuery: "",

  // Stores All Contacts / Users
  contacts: [],

  // Stores Chat Contacts
  chatContacts: [],

  // Stores Chat data(log) / Chat Messages
  chats: {},

  //Stores Chat Room of User / Chats
  chatRooms: [],
};
